<template>
  <div class="w-fit px-8 absolute left-8 bottom-8">
    <img :src="logo" alt="logo" />
  </div>
</template>

<script setup>
import logo from '/images/logo_admin.png'
</script>

<style lang="sass"></style>
